module.exports = __webpack_public_path__ + "static/media/github.a4ce94d6.svg";